import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import dynamic from 'next/dynamic'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import FaqSection from './components/FaqSection'

import ogImagePng from './assets/OgTwilioEngage.png'

const UnifiedCustomerExperiences = dynamic(() => import(`./components/UnifiedCustomerExperiences`))
const EngageInRealTime = dynamic(() => import(`./components/EngageInRealTime`))
const GainCompleteViewOfYourCustomers = dynamic(() => import(`./components/GainCompleteViewOfYourCustomers`))
const OrchestrateJourneys = dynamic(() => import(`./components/OrchestrateJourneys`))
const EngageCustomers = dynamic(() => import(`./components/EngageCustomers`))
const AiDrivenCustomer = dynamic(() => import(`./components/AiDrivenCustomer`))
const UseCasesDriveGrowth = dynamic(() => import(`./components/UseCasesDriveGrowth`))
const Testimonial = dynamic(() => import(`./components/Testimonial`))
const GettingStarted = dynamic(() => import(`@segment/templates/GettingStarted`))
const Video = dynamic(() => import(`./components/Video`))
const Resources = dynamic(() => import(`./components/Resources`))

const TwilioEngageView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Twilio Engage: The Omnichannel Customer Engagement Tool | Twilio Segment"
        pageDescription="Twilio Engage empowers marketers to drive brand growth, build and optimize personalized omnichannel campaigns and better engage customers for acquisition, conversion, and retention. "
        pageOG={ogImagePng}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <Video />
          <UnifiedCustomerExperiences />
          <EngageInRealTime />
          <GainCompleteViewOfYourCustomers />
          <OrchestrateJourneys />
          <EngageCustomers />
          <AiDrivenCustomer />
          <FaqSection />
          <Resources />
          <UseCasesDriveGrowth />
          <Testimonial />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default TwilioEngageView
